module.exports = __webpack_public_path__ + "static/media/logo-white.f8d16146.svg";